<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>
          <el-input v-model="seachShiping" style="width: 150px;" placeholder="请输入关联词"></el-input>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 100%;margin-left: 0;height: 800px;text-align: center;">

            <el-table-column

              width="100"
              label="组名"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(5,scope.row.gname,scope.row.id,1)">{{scope.row.gname}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="名称"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(1,scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="100"
              label="缩放尺"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(2,scope.row.chi,scope.row.id,2)">{{scope.row.chi}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="150"
              label="高\宽设置"
               >
               <template slot-scope="scope">
                   <div style="float: left;width: 50px;">
                     <div @click="dischange(3,scope.row.w,scope.row.id)">w:{{scope.row.w}}</div>
                     <div @click="dischange(4,scope.row.h,scope.row.id)">h:{{scope.row.h}}</div>
                   </div>
               </template>
            </el-table-column>
            <el-table-column

              width="250"
              label="图片查看\修改"
               >
              <template slot-scope="scope">

                <el-row v-if="scope.row.img_s == 0">

                  <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index,scope.row)">
                    查看图片

                  </el-col>





                </el-row>
                <el-row v-if="scope.row.img_s == 1">

                  <el-upload
                    class="avatar-uploader"

                    :action="UploadUrl(scope.row.id)"
                    :show-file-list="false"
                    @click.native="ceshi(index)"
                    :on-success="handleAvatarSuccess"
                    style="display: inline;">

                    <img v-if="scope.row.img" :src="scope.row.img" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>





                </el-row>
              </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="音乐地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(1,scope.row.url,scope.row.id)">{{scope.row.url}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="400"
              label="音乐指令"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(1,scope.row.zhiling,scope.row.id)">{{scope.row.zhiling}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="关联词"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(2,scope.row.guanjianci,scope.row.id)">{{scope.row.guanjianci}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="400"
              label="bgm"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(2,scope.row.bgm,scope.row.id)">{{scope.row.bgm}}</div>
               </template>
            </el-table-column>
            <!-- <el-table-column

              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.$index)">删除</el-col>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="kg(scope.row.id)">
                     <span v-if="scope.row.status == 1" style="color: greenyellow;">开</span>
                     <span v-if="scope.row.status == 2" style="color: crimson;">关</span>
                   </el-col>
                 </el-row>
               </template>
            </el-table-column> -->
            <!-- <el-table-column

              width="200"
              label="导入视频库"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="move(scope.row.id)">导入</el-col>

                 </el-row>
               </template>
            </el-table-column> -->
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="10"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>


    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisibleshi"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disNameshi"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisibleshi = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChangeshi()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<style>
  th div{
    text-align: center;
  }
</style>
<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
        options: [],
        delId:'',
        delIndex:'',
        dialogVisible:false,
        value: '',
        addImg:'',
        addImgs:'',
        newName:'',
        imageId: 0,
        list: [],
        search:'',
        w:0,
        h:0,
        chi:0,
        disName:'',
        disNameshi:'',

        disDialogVisible:false,
        disDialogVisibleshi:false,
        disId:0,
        disIdshi:0,
        seachName:'',
        seachShiping:'',
        gName:'',
        groupName:'',
        groupNameg:'',
        url:'无',
        zhiling:'无',
        urlmp4:'无',
        shiping:'无'


      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadList();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    seeImg(index,row){
      row['img_s'] = 1
      // this.list[index]['img_s'] = 1;
      this.$set(this.list,index,row);
      // console.log(this.list[index]['img_s'])
      // this.$forceUpdate()


    },
    seach(){
      this.loadList();
    },
    dischange(t,name,id){
      // this.tshi = t;
      // this.disId = id
      // this.disName = name
      // this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disId,
          name:this.disName,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtChanges'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.msg('名称重复','error');
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    dischangeshi(t,name,id){
      // this.tshi = t;
      // this.disIdshi = id
      // this.disNameshi = name
      // this.disDialogVisibleshi = true
    },
    dodisChangeshi(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disIdshi,
          name:this.disNameshi,
          t:this.tshi
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtChangesshi'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisibleshi = false
          this.loadList()
        }else{
          this.msg('修改失败','error');
          this.disDialogVisibleshi = false

        }



      })
      .catch(err=>{

      });
    },
    aa(t){
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
        if(t == 1){
          return y + "-" + m + "-01 00:00:00";
        }else{
          return y + "-" + m + "-" + d +" 23:59:59";
        }

    },

    UploadUrl(id){
      return "http://y31p.yoooooo.com/index.php/index/data/pythondtChange?id="+id
    },
    onChangeStripe(){
      this.loadList()
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
          shiping:this.seachShiping

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtSmusic'
      })
      .then(res=>{
        // this.groupName = res.data.group;
        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
        })

        this.count = res.data.count;
      	// this.list = res.data;

      })
      .catch(err=>{

      });
    },
    handleAvatarSuccess1(res, file){


      this.addImg = URL.createObjectURL(file.raw);
      this.addImgs = file.response.data
      console.log(this.addImgs)
    },
    handleAvatarSuccess(res, file) {


      this.list[this.imageId]['img'] = URL.createObjectURL(file.raw);
    },
    ceshi(index){
      this.imageId = index
    },
    del(id,index){
      this.dialogVisible = true
      this.delId = id
      this.delIndex = index

    },

    kg(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtkgChanges'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList()

      	}else{
          this.$message({
          	type: 'error',
          	message: '操作失败'
          });
      	}

      })
      .catch(err=>{

      });
    },
    move(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		id:this.id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtMoveshi'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
      	}

      })
      .catch(err=>{

      });
    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtDel'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.delId = 0
           this.dialogVisible = false
           this.list.splice(this.delIndex,1)
           this.delIndex = ''
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.newName == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.gName == ''){
        this.msg('请填写组名','error')
        return false
      }
      if(this.addImgs == ''){
        this.msg('请选择图片','error')
        return false
      }
      console.log(this.addImgs)
      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementdtAddTB',
      	params:{
      		name:this.newName,
          gname:this.gName,
      		url:this.addImgs,
          l_id:this.value,
          w:this.w,
          h:this.h,
          chi:this.chi,
          urls:this.url,
          zhiling:this.zhiling,
          urlmp4:this.urlmp4,
          shiping:this.shiping
      	}
      })
      .then(res=>{
      	this.tableData = res.data.data
        this.addImgs = ''
        this.addImg = ''
        this.newName = ''
        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/smusic.vue